/**
 * Menu Cache Strategy
 * Cache strategy for menu-specific game data
 */

import { BaseCacheStrategy } from './baseCacheStrategy'

export class MenuCacheStrategy extends BaseCacheStrategy {
  constructor(key) {
    super(key)
    this.isMenuKey = key.includes('-')
  }

  /**
   * Handle menu-specific cache logic
   * @param {*} data - Data to cache
   * @param {Object} processedData - Full processed data for extraction (unused - data already extracted)
   */
  setMenuData(data) {
    // Data is already extracted by GameDataProcessor.getCacheData()
    this.set(data)
  }

  /**
   * Extract appropriate data for menu keys
   * @param {Object} processedData - Full processed data
   * @returns {Array} Menu-appropriate data
   */
  extractMenuData(processedData) {
    const menuDataMap = {
      'new-games': processedData.newGamesUnlimited || [],
      'hot-games': processedData.bonusGamesUnlimited || []
    }
    return menuDataMap[this.key] || []
  }
}

export default MenuCacheStrategy
